import type { ArticleDates } from "./types";
import { isJsonObject } from "./json";
import { publicationDate } from "./readingCopy";

export function validArticleDates(value: unknown): value is ArticleDates {
  if (!isJsonObject(value) || value.version !== "imprint.article-dates.v1") return false;
  return [value.published, value.modified].every(date => date === null || (
    isJsonObject(date) && typeof date.value === "string" && date.value.length <= 64
    && typeof date.source === "string" && /^(?:meta:article:(?:published|modified)_time|meta:parsely-pub-date|jsonld:Article.date(?:Published|Modified)|feed:(?:published|updated)_at|reading_copy)$/.test(date.source)
    && !date.value.startsWith("0000") && Boolean(publicationDate(date.value))
    && (date.precision === "date" ? /^\d{4}-\d{2}-\d{2}$/.test(date.value)
      : date.precision === "datetime" && validTimestamp(date.value))
  ));
}

function validTimestamp(value: string): boolean {
  const match = /^\d{4}-\d{2}-\d{2}T(\d{2}):(\d{2})(?::(\d{2})(?:\.\d{1,9})?)?(Z|[+-]\d{2}:\d{2})$/.exec(value);
  if (!match || +match[1] > 23 || +match[2] > 59 || +(match[3] || 0) > 59 || !Number.isFinite(Date.parse(value))) return false;
  if (match[4] === "Z") return true;
  const hours = +match[4].slice(1, 3), minutes = +match[4].slice(4);
  return match[4] !== "-00:00" && hours <= 14 && minutes <= 59 && (hours !== 14 || minutes === 0);
}
